/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedUsersSkeleton.defs.js'
export { main as default } from './getOnboardingSuggestedUsersSkeleton.defs.js'
